import { Component, Input, EventEmitter, Output, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { DateFormatEnum } from "../../enum/date-format.enum";
import { DateRangeEnum } from "../../enum/date-range.enum";
import { ModalSizeEnum } from "../../enum/modal-size.enum";
import { DataRangeSelectModalComponent } from "../data-range-select-modal/data-range-select-modal.component";
import { DateUtils } from "../../utils/date.utils";


@Component({
  selector: "app-date-range-select",
  templateUrl: "./date-range-select.component.html",
  styleUrls: ["./date-range-select.component.css"]
})
export class DateRangeSelectComponent implements OnInit {
  @Input() hideTomorrow = false;
  @Input() hidePast = false;
  @Input() startDate = DateUtils.getNow();
  @Input() endDate = DateUtils.getNow();
  @Input() dateRange: string;
  @Input() dateTitle: string;
  isDateActive: Boolean;

  @Output() valueChange = new EventEmitter();
  dateTitleTemp: string;
  dateRangeEnum = DateRangeEnum;

  dateFormatEnum = DateFormatEnum;
  constructor(private translate: TranslateService,
    private modalService: NgbModal) { }

  ngOnInit() { }
  // Sipariş tarihini değiştir ekranını aç
  openModal() {
    const modalRef = this.modalService.open(DataRangeSelectModalComponent, {
      backdrop: "static", centered: true, scrollable: false, size: ModalSizeEnum.LARGE
    });
    //
    //modal  veri geçişi
    modalRef.componentInstance.hideTomorrow = this.hideTomorrow;
    modalRef.componentInstance.hidePast = this.hidePast;
    modalRef.componentInstance.startDate = this.startDate;
    modalRef.componentInstance.endDate = this.endDate;
    modalRef.componentInstance.dateRange = this.dateRange;
    modalRef.componentInstance.dateTitle = this.dateTitle;

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      // Cevap boş değilse
      if (receivedEntry) {
        //
        this.dateRange = receivedEntry.dataRange;
        this.startDate = receivedEntry.startDate;
        this.endDate = receivedEntry.endDate;
        this.isDateActive = receivedEntry.isDateActive;
        this.dateTitle = receivedEntry.dateTitle;
        this.dateRange = receivedEntry.dateRange;

        this.valueChange.emit({
          isInitial: receivedEntry.isInitial,
          startDate: this.startDate,
          endDate: this.endDate,
          isDateActive: this.isDateActive,
          dateTitle: this.dateTitle,
          dateRange: this.dateRange

        });
      }

      // modal kapat
      modalRef.close();
    });

  }


}


